import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import DMSHeader from "../DMSHeader/DMSHeader";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import FleetUserManagement from "./FleetUserManagement";

const FleetUserManagementHeader = ({ initialTab = "form" }) => {
  useEffect(() => { GridStack.init(); }, []);

  const layoutData = [
    {
      x: 0, y: 0, width: 12, height: 1, id: 0,
      component: (
        <DMSHeader
          title="User Management"
          showdownload={false}
          fileName="Fleet Users"
          showIconsForback={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0, y: 1, width: 12, height: 13, id: 1,
      component: <FleetUserManagement initialTab={initialTab} />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default FleetUserManagementHeader;
